import { AccountPreferenceKeys, OnboardingStatus } from '@ankor-io/common/types/account'

import { useUserContext } from '@/providers/user/useUserContext'
import OrganizationSetup from '@/views/components/Onboarding/OrganizationSetup'
import TeamSetup from '@/views/components/Onboarding/TeamSetup'
import VesselSetup from '@/views/components/Onboarding/VesselSetup'

export const RightSideSetup = () => {
  const { preferences, updatePreferences } = useUserContext()

  const onboardingStatus = preferences?.[AccountPreferenceKeys.ONBOARDING_STATUS]

  const handleOrganizationSave = (orgId: string) => {
    updatePreferences({
      [AccountPreferenceKeys.ONBOARDING_STATUS]: OnboardingStatus.ORG_CREATED,
      [AccountPreferenceKeys.ACTIVE_ORGANIZATION_ID]: orgId,
      [AccountPreferenceKeys.ACTIVE_VESSEL_ID]: '',
      [AccountPreferenceKeys.ACTIVE_CONNECTED_ACCOUNT_ID]: '',
    })
  }

  const handleVesselSave = (vesselId: string) => {
    updatePreferences({
      [AccountPreferenceKeys.ONBOARDING_STATUS]: OnboardingStatus.VESSEL_CREATED,
      [AccountPreferenceKeys.ACTIVE_VESSEL_ID]: vesselId,
      [AccountPreferenceKeys.ACTIVE_CONNECTED_ACCOUNT_ID]: '',
    })
  }

  // Step derived from server-side preference (source of truth)
  const showOrganizationStep = !onboardingStatus || onboardingStatus === OnboardingStatus.NOT_STARTED
  const showVesselStep = onboardingStatus === OnboardingStatus.ORG_CREATED
  const showTeamStep = onboardingStatus === OnboardingStatus.VESSEL_CREATED

  return (
    <div className="w-full lg:max-w-lg flex items-center justify-center p-4 sm:p-6 md:p-8 lg:p-16 order-1 lg:order-2 min-h-[60vh] lg:min-h-screen bg-white dark:bg-gray-900">
      {showOrganizationStep && <OrganizationSetup onSave={handleOrganizationSave} />}
      {showVesselStep && <VesselSetup onSave={handleVesselSave} />}
      {showTeamStep && <TeamSetup />}
    </div>
  )
}

export default RightSideSetup
